import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.js';
import { isFlatDesign, forms, THEME_UI_DEFAULT_KEY, INPUT_FOCUS_PSEUDO_FIELD, INPUT_HOVER_PSEUDO_FIELD } from '@costar/theme-ui';
import autocompleteClasses from './autocomplete-classes.esm.js';

var selectedStyle = {
  bg: 'primary',
  color: 'white'
};
var hoverStyle = {
  bg: 'primary.light',
  color: 'black'
};
var resetOptionHoverStyle = {
  bg: 'primary.light',
  color: 'neutral.medium'
};
var showClearIndicator = _defineProperty({}, "& .".concat(autocompleteClasses.clearIndicator), {
  opacity: 1
});
function getTagsStyle() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THEME_UI_DEFAULT_KEY;
  return _defineProperty({}, "& .".concat(autocompleteClasses.tag), {
    variant: "tags.".concat(variant),
    pl: 'xs',
    gap: 'xs',
    '.csg-tui-text:after': {
      display: 'none'
    }
  });
}
var AutocompleteTheme = {
  contextId: 'autocomplete',
  forms: {
    input: _defineProperty({}, THEME_UI_DEFAULT_KEY, function (theme, props) {
      var _outerTheme$forms$inp, _outerTheme, _outerTheme$forms, _ref2, _objectSpread3;
      var mode = props.mode,
        hidableTags = props.hidableTags,
        tagsVariant = props.tagsVariant;
      var basePreset = (_outerTheme$forms$inp = theme === null || theme === void 0 ? void 0 : (_outerTheme = theme.outerTheme) === null || _outerTheme === void 0 ? void 0 : (_outerTheme$forms = _outerTheme.forms) === null || _outerTheme$forms === void 0 ? void 0 : _outerTheme$forms.input) !== null && _outerTheme$forms$inp !== void 0 ? _outerTheme$forms$inp : forms.input;
      var baseVariant = basePreset[THEME_UI_DEFAULT_KEY](theme, _objectSpread2(_objectSpread2({}, props), {}, {
        readOnly: mode !== 'select' && props.readOnly
      }));
      return _objectSpread2(_objectSpread2(_objectSpread2({}, hidableTags ? (_ref2 = {}, _defineProperty(_ref2, "& .".concat(autocompleteClasses.tag), {
        border: 'transparent',
        bg: 'transparent',
        color: 'inherit',
        lineHeight: 1.4,
        // Cosmos does not  have 1.4, but required
        pl: 'unset',
        py: 'unset',
        pr: 'xs-3',
        // size required
        gap: 'unset',
        transition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '> .csg-tui-text': {
          p: 0,
          transition: 'padding 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
        },
        ':not(.is-last-tag)': {
          '.csg-tui-text:after': {
            content: "', '"
          }
        },
        '.csg-tui-button': {
          width: 0,
          margin: 0,
          p: 0,
          border: 'unset',
          transition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important',
          '.csg-tui-icon': {
            display: 'none'
          }
        }
      }), _defineProperty(_ref2, "& .".concat(autocompleteClasses.tag, ".is-invalid"), {
        color: 'danger'
      }), _ref2) : {}), {}, _defineProperty({}, "& .".concat(autocompleteClasses.clearIndicator), {
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        opacity: 0
      }), baseVariant), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, INPUT_FOCUS_PSEUDO_FIELD, _objectSpread2(_objectSpread2(_objectSpread2({}, baseVariant[INPUT_FOCUS_PSEUDO_FIELD]), showClearIndicator), hidableTags ? getTagsStyle(tagsVariant) : {})), _defineProperty(_objectSpread3, '&.show-focus', _objectSpread2(_objectSpread2(_objectSpread2({}, baseVariant['&.show-focus']), showClearIndicator), hidableTags ? getTagsStyle(tagsVariant) : {})), _defineProperty(_objectSpread3, INPUT_HOVER_PSEUDO_FIELD, _objectSpread2(_objectSpread2(_objectSpread2({}, baseVariant[INPUT_HOVER_PSEUDO_FIELD]), showClearIndicator), hidableTags ? getTagsStyle(tagsVariant) : {})), _objectSpread3));
    })
  },
  lists: {
    list: function list(theme) {
      var _ariaSelectedTru, _$concat, _ref3;
      var isFlatDesign$1 = isFlatDesign(theme);
      return _ref3 = {
        variant: 'scrollbar.transition',
        wordBreak: 'break-all'
      }, _defineProperty(_ref3, "& ul .".concat(autocompleteClasses.option), {
        emPaddingLeft: 'xl'
      }), _defineProperty(_ref3, "& .is-reset-option", {
        color: 'neutral.medium'
      }), _defineProperty(_ref3, "& .".concat(autocompleteClasses.option), (_$concat = {}, _defineProperty(_$concat, "&.".concat(autocompleteClasses.focused), {
        backgroundColor: isFlatDesign$1 ? 'primary.contrast' : 'primary.light',
        color: isFlatDesign$1 ? 'white' : 'black',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&[aria-disabled="true"]': {
          backgroundColor: 'unset',
          color: 'black',
          cursor: 'not-allowed'
        }
      }), _defineProperty(_$concat, '&[aria-disabled="true"]', {
        opacity: 0.6,
        cursor: 'not-allowed'
      }), _defineProperty(_$concat, '&[aria-disabled="true"]:active', {
        pointerEvents: 'none',
        backgroundColor: 'unset'
      }), _defineProperty(_$concat, '&[aria-disabled="true"]:hover', {
        backgroundColor: 'unset',
        cursor: 'not-allowed'
      }), _defineProperty(_$concat, "&.".concat(autocompleteClasses.focusVisible), isFlatDesign$1 ? {
        backgroundColor: 'primary.contrast',
        color: 'white'
      } : {
        backgroundColor: 'primary.light'
      }), _defineProperty(_$concat, '&[aria-selected="true"]', (_ariaSelectedTru = {
        backgroundColor: isFlatDesign$1 ? 'primary.moderate' : 'primary',
        color: 'white'
      }, _defineProperty(_ariaSelectedTru, "&.".concat(autocompleteClasses.focused), {
        backgroundColor: isFlatDesign$1 ? 'primary.contrast' : 'primary',
        color: 'white',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'neutral.darker'
        }
      }), _defineProperty(_ariaSelectedTru, "&.".concat(autocompleteClasses.focusVisible), isFlatDesign$1 ? hoverStyle : {
        backgroundColor: 'primary.contrast',
        color: 'white'
      }), _defineProperty(_ariaSelectedTru, '&:hover:not(.is-disabled)', _objectSpread2({}, hoverStyle)), _defineProperty(_ariaSelectedTru, '&:hover:not([aria-disabled="true"])', _objectSpread2({}, hoverStyle)), _ariaSelectedTru)), _$concat)), _ref3;
    },
    listItem: function listItem(theme) {
      var isFlatDesign$1 = isFlatDesign(theme);
      return {
        cursor: 'pointer',
        color: 'text',
        wordBreak: 'normal',
        gap: 'xs',
        '&.is-selected': isFlatDesign$1 ? {
          bg: 'primary.moderate',
          color: 'white'
        } : selectedStyle,
        '&.is-disabled': {
          cursor: 'not-allowed',
          opacity: 0.4
        },
        '&.is-active.is-reset-option, &:hover:not(.is-selected, .is-disabled).is-reset-option': _objectSpread2({}, resetOptionHoverStyle),
        '&.is-active:not(.is-reset-option), &:hover:not(.is-selected, .is-disabled, .is-reset-option)': _objectSpread2({}, hoverStyle)
      };
    },
    checkbox: {
      list: function list(theme) {
        var _$concat2;
        var isFlatDesign$1 = isFlatDesign(theme);
        return _defineProperty({
          variant: 'scrollbar.transition',
          wordBreak: 'break-all'
        }, "& .".concat(autocompleteClasses.option), (_$concat2 = {}, _defineProperty(_$concat2, "&.".concat(autocompleteClasses.focused), {
          '.csg-tui-checkbox > div': {
            ':not([data-checked])': {
              border: 'black',
              boxShadow: isFlatDesign$1 ? 'unset' : 'black.inset'
            },
            border: isFlatDesign$1 ? 'primary.contrast' : 'primary',
            boxShadow: isFlatDesign$1 ? 'unset' : 'primary.rise',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
              border: 'initial',
              boxShadow: 'initial'
            }
          }
        }), _defineProperty(_$concat2, '&[aria-disabled="true"]', {
          opacity: 0.6,
          pointerEvents: 'none'
        }), _defineProperty(_$concat2, "&.".concat(autocompleteClasses.focusVisible), {
          '.csg-tui-checkbox > div': {
            ':not([data-checked])': {
              border: 'black',
              boxShadow: isFlatDesign$1 ? 'unset' : 'black.inset'
            },
            border: isFlatDesign$1 ? 'primary.contrast' : 'primary',
            boxShadow: isFlatDesign$1 ? 'unset' : 'primary.rise'
          }
        }), _$concat2));
      },
      listItem: {
        cursor: 'pointer',
        color: 'text',
        wordBreak: 'normal',
        gap: 'xs'
      }
    }
  }
};

export default AutocompleteTheme;
//# sourceMappingURL=theme.esm.js.map
